import { Button } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

function CreateWithoutPublishingButton({ onClick, disabled = false }: Props) {
  return (
    <Button
      size="md"
      variant="solid"
      color="primary"
      className="rounded-e-none h-[38px]"
      onClick={onClick}
      disabled={disabled}
      data-intercom-target="chatbot-preview-create-collection-button"
    >
      <T kind="Create without Publishing" />
    </Button>
  );
}

export default observer(CreateWithoutPublishingButton);
